<template>
  <div>
    <div ref="legendContainer" class="chart-legend"></div>
    <div class="chart-container">
      <Pie ref="pieChart" :data="chartData" :options="pieChartOptions" :plugins="[htmlLegendPlugin]" />
    </div>
  </div>
</template>

<script>
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Colors } from 'chart.js'
import { Pie } from 'vue-chartjs'
ChartJS.register(ArcElement, Tooltip, Legend, Colors)

export default {
  name: 'PieChartWithLegend',
  components: {
    Pie
  },
  props: {
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      htmlLegendPlugin: {
        id: 'htmlLegend',
        afterUpdate: (chart) => {
          const legendContainer = this.$refs.legendContainer
          if (!legendContainer) return

          legendContainer.innerHTML = ''

          const ul = document.createElement('ul')
          ul.style.display = 'flex'
          ul.style.flexWrap = 'wrap'
          ul.style.justifyContent = 'center'
          ul.style.margin = '0 0 0 0'
          ul.style.padding = '0'

          const items = chart.options.plugins.legend.labels.generateLabels(chart)

          items.forEach(item => {
            const li = document.createElement('li')
            li.style.alignItems = 'center'
            li.style.cursor = 'pointer'
            li.style.display = 'flex'
            li.style.margin = '3px 8px'
            li.style.listStyle = 'none'

            li.onclick = () => {
              chart.toggleDataVisibility(item.index)
              chart.update()
            }

            const boxSpan = document.createElement('span')
            boxSpan.style.background = item.fillStyle
            boxSpan.style.display = 'inline-block'
            boxSpan.style.flexShrink = '0'
            boxSpan.style.height = '12px'
            boxSpan.style.width = '12px'
            boxSpan.style.marginRight = '6px'
            boxSpan.style.borderRadius = '2px'

            const textContainer = document.createElement('span')
            textContainer.style.color = item.fontColor
            textContainer.style.fontSize = '12px'
            textContainer.style.textDecoration = item.hidden ? 'line-through' : ''
            textContainer.appendChild(document.createTextNode(item.text))

            li.appendChild(boxSpan)
            li.appendChild(textContainer)
            ul.appendChild(li)
          })

          legendContainer.appendChild(ul)
        }
      }
    }
  },
  computed: {
    theme () {
      return this.$store.getters.getTheme
    },
    legendColor() {
      return this.theme === 'dark'
        ? 'rgb(157, 169, 187)'
        : 'rgb(94, 110, 130)'
    },
    pieChartOptions() {
      const legendColor = this.legendColor
      
      return {
        responsive: true,
        maintainAspectRatio: true,
        aspectRatio: 1.2,
        radius: '90%',
        borderWidth: 0,
        color: legendColor,
        plugins: {
          legend: {
            display: false,
            labels: {
              generateLabels: (chart) => {
                const datasets = chart.data.datasets
                return chart.data.labels.map((label, i) => ({
                  text: label,
                  fillStyle: datasets[0].backgroundColor?.[i] || ChartJS.defaults.backgroundColor,
                  strokeStyle: datasets[0].borderColor?.[i] || ChartJS.defaults.borderColor,
                  lineWidth: 0,
                  hidden: !chart.getDataVisibility(i),
                  index: i,
                  fontColor: legendColor
                }))
              }
            }
          },
          colors: {
            enabled: true
          },
          htmlLegend: {}
        }
      }
    }
  },
  methods: {
    handleResize() {
      this.$refs.pieChart?.chart?.resize()
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style scoped>
.chart-legend {
  min-height: 20px;
}

.chart-container {
  position: relative;
  width: 100%;
  max-width: 350px;
  margin: 0 auto;
}
</style>